import {IconButton} from '../buttons/icon-button';
import {openUploadWindow} from '../../uploads/utils/open-upload-window';
import {UploadInputType} from '../../uploads/types/upload-input-config';
import {AddAPhotoIcon} from '../../icons/material/AddAPhoto';
import {Button} from '../buttons/button';
import {UploadedFile} from '../../uploads/uploaded-file';
import {Trans} from '../../i18n/trans';
import {ReactNode} from 'react';
import {validateUpload} from '@common/uploads/uploader/validate-upload';
import {toast} from '@common/ui/toast/toast';

export const MaxImageSize = 1572864;

export interface ImageUploaderProps {
  className?: string;
  onUpload: (file: UploadedFile) => void;
  onRemove: () => void;
  value?: string | null;
  isLoading: boolean;
  title?: ReactNode;
  defaultImage?: ReactNode;
  imageRadius?: string;
}
export function AvatarImageSelector({
  value,
  isLoading,
  onUpload,
  onRemove,
  className,
  title,
  defaultImage,
  imageRadius = 'rounded-full',
}: ImageUploaderProps) {
  return (
    <div className={className}>
      {title && <div className="text-sm mb-18">{title}</div>}
      <div className="w-90 h-90 relative">
        {value ? (
          <img
            src={value}
            className={`w-full h-full object-cover ${imageRadius}`}
            alt=""
          />
        ) : (
          defaultImage
        )}
        <div className="bg-paper shadow-xl absolute -bottom-2 -right-2 rounded-full">
          <IconButton
            disabled={isLoading}
            type="button"
            size="sm"
            color="primary"
            onClick={async () => {
              await handleFileUpload(onUpload);
            }}
          >
            <AddAPhotoIcon />
          </IconButton>
        </div>
      </div>
      <Button
        type="button"
        disabled={isLoading || !value}
        variant="link"
        color="primary"
        size="xs"
        className="mt-18"
        onClick={() => {
          onRemove();
        }}
      >
        <Trans message="Remove image" />
      </Button>
    </div>
  );
}

async function handleFileUpload(onUpload: ImageUploaderProps['onUpload']) {
  const [file] = await openUploadWindow({
    types: [UploadInputType.image],
  });
  const errorMessage = validateUpload(file, {
    allowedFileTypes: [UploadInputType.image],
    maxFileSize: MaxImageSize,
  });

  if (errorMessage) {
    toast.danger(errorMessage);
  } else {
    onUpload(file);
  }
}
